import React, { Component } from 'react';
import { DatePicker, Form, Input, message, Modal, Radio, Select } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { queryBooksIncomeInfo, querySaveBooksIncome } from '@api/finance/finance';
import { queryDictExpend, queryDictIncome } from '@api/core/dict';

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { Option } = Select;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      isComLeader: false,
      type: [],
      readOnly: false,
    };
  }

  componentWillMount() {
    const { uuid } = this.props;
    const { readOnly } = this.props;
    if (readOnly) {
      this.setState({
        readOnly: true,
      });
    }
    const role = this.props.account_info.roles;
    if (uuid) {
      this.loadInfo(uuid);
    }
    const isComLeader = role.some(item => {
      return item.sign === '[ComLeader]';
    });
    this.setState({
      isComLeader,
    });
  }

  loadInfo = uuid => {
    queryBooksIncomeInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({ content: res.data });
        if (res.data.target === 0) {
          this.loadDictExpend();
        } else if (res.data.target === 1) {
          this.loadDictIncome();
        }
      } else {
        message.error(res.message);
      }
    });
  };

  loadDictExpend = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          type: res.data,
        });
      }
    });
  };

  /**
   * 获取收入类别
   */
  loadDictIncome = () => {
    queryDictIncome().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          type: res.data,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const income = this.props.form.getFieldsValue();
    const obj = {};
    obj.uuid = this.props.uuid;
    obj.ignoreFlag = income.ignoreFlag;
    obj.type = income.type;
    obj.remark = income.remark;
    this.props.form.validateFields(err => {
      if (!err) {
        querySaveBooksIncome(obj).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.handleSubmit(obj);
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { content, isComLeader, readOnly } = this.state;

    return (
      <Modal title="收支记录" visible onCancel={this.props.cancel} onOk={this.submit}>
        <Form layout="horizontal">
          <FormItem label="资金方向" {...formItemLayout}>
            {getFieldDecorator('target', {
              rules: [{ required: true, message: '请选择资金流向' }],
              initialValue: `${content.target}`,
            })(
              <RadioGroup disabled>
                <Radio value="1">收入</Radio>
                <Radio value="0">支出</Radio>
              </RadioGroup>,
            )}
          </FormItem>
          <FormItem label="收支类型" {...formItemLayout}>
            {getFieldDecorator('type', {
              rules: [{ required: true, message: '请选择收支类型' }],
              initialValue: content.type,
            })(
              <Select style={{ fontSize: '14px' }} disabled={readOnly}>
                {this.state.type.map(item => {
                  return (
                    <Option key={item.value} value={item.value}>
                      {item.key}
                    </Option>
                  );
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem label="金额" {...formItemLayout}>
            {getFieldDecorator('money', {
              rules: [{ required: true, message: '请输入初始资金' }],
              initialValue: content.target === '0' ? content.paymoney : content.money,
            })(<Input disabled addonAfter="元" type="number" />)}
          </FormItem>
          <FormItem label="收支日期" {...formItemLayout}>
            {getFieldDecorator('date', {
              rules: [{ required: true, message: '请选择发生日期' }],
              initialValue: content.date ? moment.unix(content.date / 1000) : moment(),
            })(<DatePicker disabled />)}
          </FormItem>
          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('remark', {
              initialValue: content.remark,
            })(<Input type="textarea" rows={4} disabled={readOnly} />)}
          </FormItem>
          {isComLeader ? (
            <FormItem label="资金忽略" {...formItemLayout}>
              {getFieldDecorator('ignoreFlag', {
                initialValue: content.ignoreFlag,
              })(
                <RadioGroup>
                  <Radio value={0} disabled={readOnly}>
                    不忽略
                  </Radio>
                  <Radio value={1} disabled={readOnly}>
                    非业务数据
                  </Radio>
                  <Radio value={2} disabled={readOnly}>
                    走账数据
                  </Radio>
                </RadioGroup>,
              )}
            </FormItem>
          ) : (
            ''
          )}
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({ account_info: state.account_info }))(
  Form.create({ wrappedComponentRef: true })(DetailModal),
);



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/ModalDetail.js